import { IconCloud } from "./IconCloud";

const slugs = [
  "typescript",
  "javascript",
  "dart",
  "react",
  "flutter",
  "android",
  "html5",
  "css3",
  "nodedotjs",
  "express",
  "prisma",
  "postgresql",
  "firebase",
  "nginx",
  "testinglibrary",
  "jest",
  "docker",
  "git",
  "jira",
  "github",
  "gitlab",
  "visualstudiocode",
  "androidstudio",
  "figma",
  "nestjs",
  "csharp",
  "mysql",
];

export const IconCloudComponent = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="features-inner section-inner">
          <div className="features-header text-center">
            <div className="container-sm">
              <h2 className="section-title mt-0">Tecnologías de desarrollo</h2>
              <p className="section-paragraph">
                Con una amplia experiencia en el desarrollo de aplicaciones, nos
                hemos dado cuenta que la tecnología es un factor clave para el
                éxito de cualquier proyecto.
                <br />
                <br />
                Por eso, en Ideateccr nos mantenemos actualizados con las
                últimas tendencias y tecnologías de desarrollo, asegurando un producto que cumpla con las expectativas de nuestros clientes.
              </p>
            </div>
          </div>
          <div className="relative flex size-full max-w-lg items-center justify-center overflow-hidden rounded-lg border bg-background px-20 pb-20 pt-8 ">
            <IconCloud iconSlugs={slugs} />
          </div>
        </div>
      </div>
    </section>
  );
};
